
<div style="margin: auto; position: fixed; left: 25%; top: 45%; right: 25%">
  <div class="ppImage">
    <img src="../../assets/images/powerPortal_Qualus.png" style="width: 80%; margin-left: 10%">
  </div>
  <label class="textClass" style="font-size: medium; margin-top: 5px;">You are currently logged out</label>
  <label class="textClass logIn" (click)="logIn()">Log In</label>
</div>
